import { useRecoilValue } from 'recoil'
import { PartnerListData } from 'src/recoil/common'
import { PartnerListType } from 'src/types/type'
import { LegacyRef } from 'react'
import { BannerWrap } from 'src/styles/styledcomponent/views/mkt03/banner'

interface BannerProps {
  RefElement: LegacyRef<HTMLImageElement>
}
const Banner = ({ RefElement }: BannerProps): JSX.Element => {
  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const { Image1, Image2 } = PartnerData
  const host = window.location.host
  // 개발기에는 이미지가 존재하지 않습니다.
  return (
    <BannerWrap>
      {
        (host.includes('localhost') || host.includes('dev-') || host.includes('5.0')) ? 
        (
          <>
            <img src={`https://dev-img.familycare.ai${Image1}`} alt="배너1" />
            <img src={`https://dev-img.familycare.ai${Image2}`} alt="배너2" ref={RefElement} />
          </>
        ) 
        : (
          <>
            <img src={`https://img.familycare.ai${Image1}`} alt="배너1" />
            <img src={`https://img.familycare.ai${Image2}`} alt="배너2" ref={RefElement} />
          </>
        ) 
      }
    </BannerWrap>
  )
}
export default Banner
